import { TenantProvider } from '../../common/TenantPersona';
import { MlmOrderContext, MlmOrderType } from '~/tenants/mlm/model/MlmOrder';
import MlmPhotosConfig from '~/tenants/mlm/performable/photos/MlmPhotosConfig';
import MlmHeadshotConfig from '~/tenants/mlm/performable/headshot/MlmHeadshotConfig';
import Mlm3dConfig from '~/tenants/mlm/performable/3d/Mlm3dConfig';
import MlmVirtualConfig from '~/tenants/mlm/performable/virtual/MlmVirtualConfig';
import MlmWalkthroughConfig from '~/tenants/mlm/performable/walkthrough/MlmWalkthroughConfig';
import MlmAerialConfig, { MlmAerialType } from '~/tenants/mlm/performable/aerial/MlmAerialConfig';
import MlmFloorplanConfig from '~/tenants/mlm/performable/floorplan/MlmFloorplanConfig';
import MlmVirtualStagingConfig from '~/tenants/mlm/performable/staging/MlmVirtualStagingConfig';

export enum MlmProviderId {
  SOPHIA_BEDNARIK = 1,
  JACK_SANDONE = 2,
  MITCH_POWERS = 3,
  JACK_STEPP = 4,
}

export interface MlmProviderStaticData {
  performable_walkthrough?: boolean;
  performable_floorplan?: boolean;
  performable_aerialv?: boolean;
  performable_aerialp?: boolean;
  commercial?: boolean;
}

export default class MlmProvider extends TenantProvider<MlmProviderStaticData> {
  canPerform(context: MlmOrderContext, job: MlmOrderContext['jobs'][0]): true | string {
    if (context.metadata.type === MlmOrderType.COMMERCIAL && !this.config.commercial) {
      return 'This provider does not do commercial orders.';
    }

    if (job.performable_id === MlmWalkthroughConfig.id && !this.config.performable_walkthrough) {
      return 'This provider does not do headshots.';
    }

    if (job.performable_id === MlmFloorplanConfig.id && !this.config.performable_floorplan) {
      return 'This provider does not do floorplans.';
    }

    if (job.performable_id === MlmAerialConfig.id) {
      if (job.metadata.type === MlmAerialType.VIDEO && !this.config.performable_aerialv) {
        return 'This provider does not do video aerials.';
      }

      if (job.metadata.type === MlmAerialType.PHOTO && !this.config.performable_aerialp) {
        return 'This provider does not do photo aerials.';
      }
    }

    return true;
  }

  get performableIds(): string[] {
    return [
      Mlm3dConfig.id,
      MlmAerialConfig.id,
      MlmFloorplanConfig.id,
      MlmHeadshotConfig.id,
      MlmPhotosConfig.id,
      MlmVirtualStagingConfig.id,
      MlmVirtualConfig.id,
      MlmWalkthroughConfig.id,
    ];
  }
}
